import React from 'react';
import {bindActionCreators} from "redux";
import {tokenAction} from "../../redux-stuffs/actions/token_action";
import {connect} from "react-redux";
import {withRouter, Link} from "react-router-dom";
import Header from "../../components/Header";
import {accessTokenState} from '../../atoms';
import withRecoil from '../../withRecoil';

class AddToBalance extends React.Component {

    render() {
        // const {isToggled} = this.state
        return (
            <div>
                <Header/>
                <div className="account-container">
                    <div style={{ position: 'relative', marginBottom: '20px', textAlign: 'center', width: '100%' }}>
                        <button onClick={() => this.props.history.push({ pathname: '/dashboard' })}
                                style={{
                                    position: 'absolute', left: '0', top: '50%',
                                    transform: 'translateY(-50%)', border: 'none',
                                    background: 'none', cursor: 'pointer'
                                }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 19l-7-7 7-7" stroke="#333" strokeWidth="2"
                                      strokeLinecap="round" strokeLinejoin="round" />
                                <line x1="8" y1="12" x2="20" y2="12"
                                      stroke="#333" strokeWidth="2"
                                      strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                        <div className='spare'><h2 style={{ textAlign: "center", margin: "0" }}>How would you like to fund your balance?</h2></div>
                    </div>

                    <div className="help-button">
                        <button onClick={()=>this.props.history.push("/fund-account-stripe")} className="help-button btn">Fund With Stripe</button>
                        <button onClick={()=>this.props.history.push("/promo")} className="help-button btn">Use Promo Code</button>
                    </div>
                </div>
            </div>
        );
    };
}

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            tokenAction: tokenAction,
        },
        dispatch,
    );

const mapStateToProps = state => {
    return {
        token: state.token,
        profile: state.profile
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withRecoil(AddToBalance, [accessTokenState])));
